/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

export enum SkeletonTypes {
    PRODUCTS,
    ORDERS,
    INVOICES,
    FAVORITE_RECIPES,
    DOCUMENTS,
    CONTRACTS,
    DELIVERY_NOTES,
    CART,
    CHECKOUT,
    CHECKOUT_DELIVERY,
    CHECKOUT_PAYMENT,
    CHECKOUT_CONFIRMATION,
    RECIPE_LIST,
    PRODUCT_FINDER,
    RECIPE_FINDER,
    SEARCH_FINDER,
    ECOM_VARIATION
}
